export enum VirtualAppAction {
    Refresh = 'refresh',
}
